import { InjectionToken } from '@angular/core';
import { TopToolbarStrategyFactory } from '../../ports/toolbar-strategy-factory.port';

export const TOOLBAR_STRATEGY_FACTORY_TOKEN = new InjectionToken<TopToolbarStrategyFactory>('TOOLBAR_STRATEGY_FACTORY');
